import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="mt-16 bg-secondary-900 text-background-50">
      <div className="mx-auto grid w-full max-w-[1240px] grid-cols-1 gap-8 px-4 py-12 md:grid-cols-4 md:px-6">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-secondary-950">
              <i className="ri-film-line text-xl" />
            </span>
            <span className="font-heading text-xl font-extrabold text-background-50">风驰影院</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
            风驰影院是专业的影视内容展示与资讯平台，汇聚最新电影、电视剧资源与权威影视资讯，帮助你轻松查找并了解热门影视作品动态。本站仅提供资源展示与信息查询，暂不提供在线播放与下载功能。
          </p>
        </div>

        <div>
          <h4 className="font-heading text-sm font-bold text-background-100">内容导航</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            {[
              { to: '/category/movie', label: '最新电影' },
              { to: '/category/tv', label: '热门电视剧' },
              { to: '/category/news', label: '影视资讯' },
              { to: '/search', label: '搜索影片' }
            ].map((link) => (
              <li key={link.to}>
                <Link to={link.to} className="text-background-300 transition hover:text-accent-400">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-bold text-background-100">关于与帮助</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li>
              <Link to="/about" className="text-background-300 transition hover:text-accent-400">
                关于我们
              </Link>
            </li>
            <li>
              <Link to="/about#contact" className="text-background-300 transition hover:text-accent-400">
                联系我们
              </Link>
            </li>
            <li>
              <Link to="/about#usage" className="text-background-300 transition hover:text-accent-400">
                使用说明
              </Link>
            </li>
            <li>
              <a href="mailto:contact@fengchi-cinema.com" className="text-background-300 transition hover:text-accent-400">
                contact@fengchi-cinema.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex w-full max-w-[1240px] flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-background-400 sm:flex-row md:px-6">
          <p>&copy; 2025 风驰影院 FengChi Cinema. 保留所有权利。</p>
          <p>本站内容仅用于影视资源展示与资讯演示，不提供在线播放与下载服务。</p>
        </div>
      </div>
    </footer>
  );
}